import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { RootNode } from "lexical";
import React, { useEffect, useMemo, useState } from "react";

import Typography from "../../../Text";
import css from "../../theme/theme.module.scss";

/**
 * A plugin that displays a character counter for the editor.
 */
export function CharacterCounterPlugin({ maxLength }: { maxLength: number }) {
	const [editor] = useLexicalComposerContext();
	const [usedCharacters, setUsedCharacters] = useState(0);
	const charsDisplay = useMemo(() => {
		return (
			<Typography size="caption" weight="regular">
				{`${usedCharacters}/${maxLength}`}
			</Typography>
		);
	}, [maxLength, usedCharacters]);

	useEffect(() => {
		return editor.registerNodeTransform(RootNode, (rootNode: RootNode) => {
			const textContentSize = rootNode.getTextContentSize();
			setUsedCharacters(textContentSize);
		});
	}, [editor]);

	const className =
		usedCharacters > maxLength ? `${css.characterCounter} ${css.limitExceeded}` : css.characterCounter;

	return React.createElement("span", { className, "data-testid": "character-counter" }, charsDisplay);
}
